module.exports = {"projectName":"LINKs","copyright":"Copyright © HIBIYA-KADAN All Rights Reserved.","styleImageMaxSelect":10,"apiURL":"https://develop-links-api.hibiyakadan-wedding.com/meeting","imageURL":"https://develop-links.hibiyakadan-wedding.com/images","isAwsChime":true,"UrlTransitionTimeLimit":300000,"floristMeetingVirtualBackgroundImageURL":"https://develop-links.hibiyakadan-wedding.com/images/meeting-virtual-background/florist/オンライン背景.jpg","customerMeetingVirtualBackgroundImageURL":"https://develop-links.hibiyakadan-wedding.com/images/meeting-virtual-background/customer/オンライン背景.jpg"}


//////////////////
// WEBPACK FOOTER
// ./src/config/config.json
// module id = QkNq
// module chunks = 1